"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.fetchMatch = fetchMatch;

/**
 * Helper for creating fetch match functions.
 *
 * @param match Can be a string (URL), regular expression (partial URL), or
 * an options object containing a `method` and/or `url` properties.
 */
function fetchMatch(match) {
  return typeof match === 'string' ? function (url) {
    return url === match;
  } : match instanceof RegExp ? function (url) {
    return match.test(url);
  } : function (matchUrl) {
    var matchMethod = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GET';
    matchMethod = matchMethod.toUpperCase();

    if (matchUrl instanceof RegExp) {
      return function (url) {
        var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref$method = _ref.method,
            method = _ref$method === void 0 ? 'GET' : _ref$method;

        return matchUrl.test(url) && method.toUpperCase() === matchMethod;
      };
    } else {
      return function (url) {
        var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref2$method = _ref2.method,
            method = _ref2$method === void 0 ? 'GET' : _ref2$method;

        return url === matchUrl && method.toUpperCase() === matchMethod;
      };
    }
  }(match.url, match.method);
}